import type { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const CustomerInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/customer-invoice",
            component: () => loadView(import("./CustomerInvoiceTable.vue")),
        },
        build(filter?: { status?: Enums.InvoiceStatusEnum.Values }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/customer-invoice?&filter=${encoded}`;
            }

            return "/customer-invoice";
        },
    },
    create: {
        route: {
            path: "/customer-invoice/create/:customerId?/:subscriptionId?",
            component: () => loadView(import("./CustomerInvoiceCreate.vue")),
        },
        build(params: { customerId?: string; subscriptionId?: string }) {
            if (isNotNil(params.customerId) && isNotNil(params.subscriptionId)) {
                return `/customer-invoice/create/${params.customerId}/${params.subscriptionId}`;
            } else if (isNotNil(params.customerId)) {
                return `/customer-invoice/create/${params.customerId}`;
            } else {
                return "/customer-invoice/create";
            }
        },
    },
    detail: {
        route: {
            path: "/customer-invoice/detail/:id",
            component: () => loadView(import("./CustomerInvoiceDetail.vue")),
        },
        build(id: string) {
            return `/customer-invoice/detail/${id}`;
        },
    },
});
